namespace Nobox.Nobox {
    export interface AccountRow {
        Id?: number;
        TenantId?: number;
        Name?: string;
        Code?: string;
        Category?: string;
        Info?: string;
        Status?: number;
        Channel?: number;
        ChannelNm?: string;
        Symbol?: number;
        ApiId?: string;
        ApiClient?: string;
        ApiSecret?: string;
        ApiExtra?: string;
        BotActive?: number;
        BotName?: string;
        BotEngine?: string;
        BotEndpoint?: string;
        BotChannel?: string;
        BotUsername?: string;
        BotPassword?: string;
        BotOptions?: string;
        Users?: string;
        IsSMTP?: string;
        Host?: string;
        Port?: string;
        UseSSL?: number;
        From?: string;
        Username?: string;
        Password?: string;
        Provider?: string;
        BaseUrlApi?: string;
        EndpointApi?: string;
        KeyApi?: string;
        FromApi?: string;
        In?: string;
        Up?: string;
    }

    export namespace AccountRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Nobox.Account';
        export const lookupKey = 'Nobox.Account';

        export function getLookup(): Q.Lookup<AccountRow> {
            return Q.getLookup<AccountRow>('Nobox.Account');
        }
        export const deletePermission = 'Accounts:Delete';
        export const insertPermission = 'Accounts:Modify';
        export const readPermission = 'Accounts:View';
        export const updatePermission = 'Accounts:Modify';

        export declare const enum Fields {
            Id = "Id",
            TenantId = "TenantId",
            Name = "Name",
            Code = "Code",
            Category = "Category",
            Info = "Info",
            Status = "Status",
            Channel = "Channel",
            ChannelNm = "ChannelNm",
            Symbol = "Symbol",
            ApiId = "ApiId",
            ApiClient = "ApiClient",
            ApiSecret = "ApiSecret",
            ApiExtra = "ApiExtra",
            BotActive = "BotActive",
            BotName = "BotName",
            BotEngine = "BotEngine",
            BotEndpoint = "BotEndpoint",
            BotChannel = "BotChannel",
            BotUsername = "BotUsername",
            BotPassword = "BotPassword",
            BotOptions = "BotOptions",
            Users = "Users",
            IsSMTP = "IsSMTP",
            Host = "Host",
            Port = "Port",
            UseSSL = "UseSSL",
            From = "From",
            Username = "Username",
            Password = "Password",
            Provider = "Provider",
            BaseUrlApi = "BaseUrlApi",
            EndpointApi = "EndpointApi",
            KeyApi = "KeyApi",
            FromApi = "FromApi",
            In = "In",
            Up = "Up"
        }
    }
}
